import  { useState, useEffect } from 'react'

export default function useWidth () {
  const [height, setHeight] = useState(window.innerHeight)
  
  useEffect(()=>{
    window.addEventListener("resize", () => {
      setHeight(window.innerHeight)
    })
  },[])

  return height
}